export default "__VITE_ASSET__9b0324e2__"